export default "__VITE_ASSET__BXLtS2eb__"